import React, { useState, useRef, useEffect } from 'react';

const Main3_slider1 = ({ slider3Autostart }) => {
  let rendered = false;
  const [animClass, setAnimClass] = useState('');
  const imgRef = useRef(null);
  const imageObserver = new IntersectionObserver(
    (entries, imgObserver) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !rendered) {
          rendered = true;
          slider3Autostart();
          setTimeout(() => {
            setAnimClass('a1');
            setTimeout(() => {
              setAnimClass();
              setTimeout(() => {
                setAnimClass('a2');
                setTimeout(() => {
                  setAnimClass('a2 a3');
                }, 600);
              }, 500);
            }, 400);
          }, 200);
        } else {
          // setAnimClass('');
        }
      });
    },
    { threshold: 0.5 },
  );

  useEffect(() => {
    imageObserver.observe(imgRef.current);
  }, []);

  return (
    <div className={'main3_slide_img main3_slide_img1 ' + animClass}>
      <svg
        width="600"
        viewBox="0 0 600 512"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        ref={imgRef}
      >
        <foreignObject x="0" y="0" width="600" height="512">
          <img
            alt="Slide 1"
            srcSet="/static/i/main3_slide1_1.webp, /static/i/main3_slide1_1@2x.webp 2x"
            loading="lazy"
          />
        </foreignObject>
        <g className="el2">
          <path
            d="M115.339 179.466C114.609 176.469 113.85 173.472 113.101 170.475C112.235 167.039 111.369 163.602 110.503 160.165L108.165 150.854C107.38 147.657 106.584 144.467 105.778 141.283L103.38 131.763C102.581 128.576 101.792 125.399 100.982 122.212C100.123 118.775 99.2441 115.339 98.3849 111.892L95.2379 99.274C95.2047 99.1931 95.1573 99.1187 95.0981 99.0542L92.2908 99.7835L76.1764 103.78C73.9885 104.329 71.8206 104.949 69.6127 105.428C68.1082 105.721 66.5511 105.576 65.1271 105.008C65.0484 104.984 64.9683 104.964 64.8873 104.949L64.6675 104.819C64.0781 104.469 63.4786 104.149 62.9192 103.75C62.2384 103.228 61.6419 102.605 61.1509 101.901C60.2874 100.526 59.7098 98.9898 59.4525 97.3859C58.2071 92.384 56.955 87.3889 55.6962 82.4003C55.0768 79.9128 54.4374 77.4052 53.808 74.9376L53.6581 74.2882C53.5323 74.2687 53.4043 74.2687 53.2785 74.2882L44.2872 76.526L34.9662 78.8338L26.0548 81.0616L16.7738 83.3894C13.7767 84.1387 10.7796 84.8979 7.83244 85.6272C6.548 85.8653 5.30795 86.3 4.15599 86.916C2.68124 87.8156 1.51155 89.1385 0.799234 90.7123C-0.0136914 92.4354 -0.214568 94.3843 0.229785 96.237C0.619408 97.8954 1.039 99.5438 1.4586 101.232L3.45667 109.284C4.33582 112.761 5.21164 116.238 6.08413 119.714C6.93664 123.078 7.78248 126.448 8.62167 129.824C9.4209 133.011 10.2201 136.188 11.0094 139.375L13.2572 148.367C14.0065 151.364 14.7657 154.361 15.505 157.298C16.2443 160.235 17.0136 163.292 17.7628 166.289L19.9807 175.201C20.2804 176.389 20.5901 177.578 20.8998 178.767C20.8998 178.857 20.8998 178.957 20.8998 179.047C21.2495 180.436 21.5991 181.824 21.8988 183.203C22.6581 186.207 23.4107 189.204 24.1567 192.194C24.886 195.081 25.6152 197.969 26.3246 200.856C26.5469 201.945 26.9379 202.994 27.4834 203.963C28.1084 204.984 28.9343 205.868 29.9111 206.56C30.7419 207.128 31.6646 207.547 32.6385 207.799C33.9996 208.207 35.4453 208.241 36.8244 207.899L47.574 205.232C52.0697 204.113 56.5653 202.964 61.051 201.835C64.7174 200.916 68.3839 200.027 72.0404 199.108L85.5473 195.701C88.5444 194.942 91.5415 194.212 94.5386 193.473L108.805 189.896C109.921 189.669 110.978 189.214 111.911 188.561C112.844 187.908 113.633 187.07 114.23 186.1C114.872 185.135 115.303 184.045 115.494 182.902C115.685 181.759 115.632 180.588 115.339 179.466ZM87.6653 170.905C86.8143 171.735 85.7173 172.268 84.5383 172.423L74.0984 175.021L61.4406 178.208L50.5511 180.915C49.8643 181.129 49.1584 181.277 48.4432 181.355C47.6895 181.384 46.9443 181.186 46.3052 180.785C45.7404 180.433 45.2568 179.966 44.8865 179.413C44.5162 178.86 44.2677 178.235 44.1573 177.578C43.5279 174.861 42.8286 172.164 42.1593 169.466C42.1404 169.398 42.1171 169.331 42.0893 169.266C41.5299 167.029 40.9904 164.791 40.4309 162.563L37.6736 151.573C36.8744 148.397 36.0651 145.21 35.2859 142.033C35.1283 141.432 35.1084 140.804 35.2278 140.195C35.3471 139.586 35.6027 139.012 35.9752 138.516C36.7098 137.562 37.7825 136.925 38.9723 136.738C42.6588 135.839 46.3352 134.9 50.0217 133.98L63.5386 130.594C64.2679 130.414 64.9872 130.204 65.7065 130.014L67.7645 129.505L72.3401 128.396C73.2392 128.176 74.1283 127.936 75.0275 127.747C75.9399 127.596 76.8757 127.788 77.6549 128.286C78.1261 128.538 78.5411 128.883 78.8743 129.3C79.2076 129.717 79.4521 130.198 79.5931 130.714C80.0826 132.452 80.4822 134.21 80.9218 135.959L83.4693 146.129C84.0221 148.367 84.5782 150.601 85.1377 152.832L87.4455 162.023C87.905 163.842 88.4445 165.65 88.7742 167.488C88.8754 168.105 88.8275 168.737 88.6346 169.331C88.4417 169.925 88.1093 170.465 87.6653 170.905Z"
            fill="#F3B60A"
          />
          <path
            d="M95.098 99.0543L92.2907 99.7836L76.1763 103.78C73.9884 104.329 71.8205 104.949 69.6127 105.428C68.1081 105.721 66.551 105.576 65.127 105.009C65.0483 104.984 64.9683 104.964 64.8872 104.949L64.6674 104.819C64.078 104.469 63.4786 104.149 62.9191 103.75C62.2383 103.228 61.6419 102.605 61.1508 101.902C60.2873 100.526 59.7097 98.9898 59.4525 97.3859C58.207 92.3841 56.9549 87.3889 55.6961 82.4004C55.0767 79.9128 54.4373 77.4052 53.8079 74.9376L53.6581 74.2882C53.738 74.2882 53.8279 74.2882 53.8779 74.2882L58.6932 77.2054C59.962 77.9746 61.2507 78.7239 62.5195 79.4932L66.5157 81.9009L72.7197 85.5873C74.1583 86.4465 75.5869 87.3256 77.0155 88.1848L79.5031 89.6733L83.5991 92.131L85.9169 93.5596C87.0958 94.2489 88.2746 94.9382 89.4535 95.6476C90.6323 96.3569 91.5415 96.9263 92.5905 97.5657L95.098 99.0543Z"
            fill="#F9DB86"
          />
          <path
            d="M81.0317 160.065L47.7738 168.397L42.9585 149.016L45.0365 148.486L55.1567 145.939L64.7075 143.551L73.3391 141.383C74.2083 141.164 75.0874 140.954 75.9466 140.714C76.2064 140.644 76.2563 140.794 76.3063 140.964C76.7658 142.792 77.2154 144.63 77.6749 146.458C78.6607 150.408 79.6597 154.357 80.672 158.307C80.752 158.846 80.9218 159.446 81.0317 160.065Z"
            fill="#F3B60A"
          />
        </g>
        <foreignObject className="el3" x="145" y="50" width="103" height="91">
          <img
            alt="Slide 2"
            srcSet="/static/i/main3_slide1_5.webp, /static/i/main3_slide1_5@2x.webp 2x"
            loading="lazy"
          />
        </foreignObject>
        <foreignObject className="el1" x="162" y="356" width="303" height="68">
          <img
            alt="Slide 3"
            srcSet="/static/i/main3_slide1_3.webp, /static/i/main3_slide1_3@2x.webp 2x"
            loading="lazy"
          />
        </foreignObject>
        <foreignObject x="174" y="400" width="52" height="51">
          <img
            alt="Slide 4"
            srcSet="/static/i/main3_slide1_4.webp, /static/i/main3_slide1_4@2x.webp 2x"
            loading="lazy"
          />
        </foreignObject>
        <foreignObject className="el4" x="257" y="81" width="306" height="324">
          <img
            alt="Slide 5"
            srcSet="/static/i/main3_slide1_2.webp, /static/i/main3_slide1_2@2x.webp 2x"
            loading="lazy"
          />
        </foreignObject>
      </svg>
    </div>
  );
};

export default Main3_slider1;
